<template>
  <div id="s_file">
    <div>
      <div class="uploader">
        <i class="el-icon-upload2"></i>
        <span>上传文件</span>
        <el-upload
          :before-upload="handleBeforeUploadFile"
          :on-success="handleFileUploadSuccess"
          :show-file-list="false"
          :headers="headers"
          action="/declare/Upload/upfile"
        >
        </el-upload>
      </div>
      <div class="uploader-file" v-if="file.uri" @click="handleToPreviewFile">
        <i class="el-icon-paperclip"></i>
        <p>企业简介</p>
      </div>
    </div>
    <p class="uploader_tips">只可上传ppt或者pdf文件</p>
  </div>
</template>

<script>
export default {
  name: "singleFileUpload",
  props: {
    file: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  data() {
    return {
      headers: {},
    };
  },
  created() {
    this.headers = {
      token: localStorage.getItem("token"),
    };
  },
  methods: {
    handleBeforeUploadFile(file) {
      if (
        file.type !== "application/vnd.ms-powerpoint" &&
        file.type !== "application/pdf"
      ) {
        this.$message.warning("只能上传PPT或者PDF格式的文件！");
        return false;
      } else if (file.size > 1024 * 1024 * 100) {
        this.$message.warning("上传的图片大小不可超过100M");
        return false;
      }
      this.$emit("handleUploading");
    },
    handleFileUploadSuccess(res) {
      if (res.code == 1) {
        this.$emit("handleUploadSuccess", res.data);
        this.$message.success(res.msg);
      } else {
        this.$emit("handleUploadSuccess");
        this.$message.error(res.msg);
      }
    },
    handleToPreviewFile() {
      window.open(this.file.uri, "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
#s_file {
  > div {
    display: flex;
    align-items: center;
    .uploader {
      width: 106px;
      height: 32px;
      border: 1px solid;
      border-color: rgba(0, 0, 0, 0.15);
      border-radius: 6px;
      color: rgba(0, 0, 0, 0.88);
      display: flex;
      align-items: center;
      font-size: 14px;
      cursor: pointer;
      position: relative;
      i {
        margin-left: 14px;
      }
      span {
        margin-left: 8px;
      }
      /deep/ .el-upload {
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        position: absolute;
      }
    }
    .uploader:hover {
      color: #e40080;
      border-color: #e40080;
    }
    .uploader-file {
      margin-left: 12px;
      display: flex;
      align-items: center;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.88);
      cursor: pointer;
      i {
        margin-right: 4px;
      }
    }
    .uploader-file:hover {
      color: #e40080;
      font-weight: 600;
    }
  }
  .uploader_tips {
    color: #999;
    font-size: 12px;
    margin-top: 8px;
    line-height: 12px;
  }
}
</style>